import { render, staticRenderFns } from "./PavMatrixLegend.vue?vue&type=template&id=e86931d6&scoped=true&"
import script from "./PavMatrixLegend.vue?vue&type=script&lang=js&"
export * from "./PavMatrixLegend.vue?vue&type=script&lang=js&"
import style0 from "./PavMatrixLegend.vue?vue&type=style&index=0&id=e86931d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86931d6",
  null
  
)

export default component.exports